import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CustomValidators } from '@aeCore/helpers/validation.helper';
import { NzInputDirective, NzInputGroupComponent } from 'ng-zorro-antd/input';
import { AeFormErrorComponent } from '@aeShared/components/ae-form-error/ae-form-error.component';
import { AeButtonComponent } from '@aeShared/components/ae-button/ae-button.component';
import { AeIconsComponent } from '@aeShared/components/ae-icons/ae-icons.component';
import { TranslatePipe } from '@ngx-translate/core';
import { FormErrorPipe } from '@aeShared/pipes/form-error.pipe';
import { PasswordStrengthComponent } from '@aeShared/components/password-strength/password-strength.component';
import { ForgetPassword } from '@aeCore/enums/forget-password.enum';
import { Router, RouterLink } from '@angular/router';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { UserService } from '@aeCore/services/user.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '@aeCore/services/auth.service';

@Component({
  selector: 'app-set-new-password',
  imports: [
    NzInputGroupComponent,
    ReactiveFormsModule,
    NzInputDirective,
    AeFormErrorComponent,
    AeButtonComponent,
    AeIconsComponent,
    TranslatePipe,
    FormErrorPipe,
    PasswordStrengthComponent,
    RouterLink,
    NzIconDirective,
  ],
  templateUrl: './set-new-password.component.html',
  standalone: true,
  styleUrl: './set-new-password.component.scss',
})
export class SetNewPasswordComponent implements OnInit {
  protected readonly ForgetPassword = ForgetPassword;
  @Input() token!: string;
  forgotPasswordConfirmForm!: FormGroup;
  showPasswordAsText = false;
  showConfirmPasswordAsText = false;
  showOldPasswordAsText = false;
  state: ForgetPassword = ForgetPassword.RESET_PASSWORD;

  constructor(
    private userService: UserService,
    private destroyRef: DestroyRef,
    private authService: AuthService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.forgotPasswordConfirmForm = new FormGroup(
      {
        oldPassword: new FormControl('', [Validators.required]),
        password: new FormControl('', [
          Validators.required,
          CustomValidators.password(),
        ]),
        confirmPassword: new FormControl('', [Validators.required]),
      },
      {
        validators: CustomValidators.passwordMatchValidator(
          'password',
          'confirmPassword',
        ),
      },
    );
    if (this.token) {
      this.forgotPasswordConfirmForm.removeControl('oldPassword');
    }
  }

  onConfirmForgotPasswordSubmit() {
    if (this.forgotPasswordConfirmForm.invalid) {
      this.forgotPasswordConfirmForm.markAllAsTouched();
      return;
    }
    if (this.token) {
      this.userService
        .forgotConfirm({
          password: this.forgotPasswordConfirmForm.value.password,
          token: this.token,
        })
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.router.navigateByUrl('auth')
        });
    } else {
      this.userService
        .resetPassword({
          newPassword: this.forgotPasswordConfirmForm.value.password,
          oldPassword: this.forgotPasswordConfirmForm.value.oldPassword,
        })
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.authService.logout();
          this.authService.removeAuthData();
        });
    }
  }
}
